import {isNumber, sum} from "lodash";

import {magicDataUnity} from "@/utils/magic-traduction.ts";

import  {
    ExtractionSheetArticleMeasuresElementDto
} from "@/models/interfaces/dtos/extraction/extraction-sheet-article-element-dto.ts";
import ProjectMeasures from "@/pages/takeoff/context/project-measure/models/project-measures.ts";
import MeasureType from "@/pages/takeoff/context/project-measure/models/measure-type.ts";
import Measure from "@/pages/takeoff/context/project-measure/models/measure.ts";
import ExtractionOperation, {operationMap} from "../enums/extraction-operation.ts";
import ExtractionSheetArticleElementBase from "./extraction-sheet-article-element-base.ts";
import ExtractionArticleElementType from "../enums/extraction-article-element-type.ts";

/**
 *  Représente un article qui possède des données venant de la BDD Baamer.
 *  Prends en compte des bâtiments et étages avec des id de type GUID.
 */
class ExtractionSheetArticleMeasuresElement extends ExtractionSheetArticleElementBase {

    associatedStoreysIds: string[];
    
    associatedMeasureTypeId: string;
    
    associatedMeasureTypeName: string;

    associatedMeasures: Measure[];
    
    constructor(id: string, parentArticleId: string, associatedMeasureTypeId: string, associatedMeasureTypeName: string, associatedStoreysIds: string[], trackedMeasures: Measure[], trackedDataType: string, unity: string, operation?: ExtractionOperation) {
        super(id, parentArticleId, ExtractionArticleElementType.MEASURE, trackedDataType, unity, operation);
        this.associatedStoreysIds = associatedStoreysIds;
        this.associatedMeasureTypeId = associatedMeasureTypeId;
        this.associatedMeasureTypeName = associatedMeasureTypeName;
        this.associatedMeasures = trackedMeasures;
        this.elements = trackedMeasures.length;
        this.updateCalculValue();
    }

    static fromDto(dto: ExtractionSheetArticleMeasuresElementDto, parentArticleId: string, projectMeasures: ProjectMeasures, measureTypes: MeasureType[]): ExtractionSheetArticleMeasuresElement {
        const associatedMeasures: Measure[] = [];
        dto.associatedStoreysIds.forEach(storeyId => {
            const storey = projectMeasures.getStorey(storeyId);
            if(storey == null) return;
            associatedMeasures.push(...storey.measures.filter(m => m.measureTypeId === dto.associatedMeasureTypeId));
        });

        const associatedMeasureTypeName = measureTypes.find(mt => mt.measureTypeId === dto.associatedMeasureTypeId)?.name ?? '';
        const unity = magicDataUnity(dto.dataKey);

        const element = new ExtractionSheetArticleMeasuresElement(
            crypto.randomUUID(),
            parentArticleId,
            dto.associatedMeasureTypeId,
            associatedMeasureTypeName,
            dto.associatedStoreysIds,
            associatedMeasures,
            dto.dataKey,
            unity,
            operationMap.find(op => op.label === dto.operation)?.value ?? undefined
        );
        
        element.elements = associatedMeasures.length;
        element.updateCalculValue();
        return element;
    }

    // addStorey(storeyId: string, trackedStoreyMeasures: Measure[]) {
    //     this.associatedStoreysIds.push(storeyId);
    //     this.associatedMeasures.push(...trackedStoreyMeasures);
    //     this.updateCalculValue();
    // }
    //
    // removeStorey(storeyId: string, trackedStoreyMeasures: Measure[]) {
    //     const index = this.associatedStoreysIds.indexOf(storeyId);
    //     if (index !== -1) {
    //         this.associatedStoreysIds.splice(index, 1);
    //         this.associatedMeasures = this.associatedMeasures.filter(m => !trackedStoreyMeasures.includes(m));
    //         this.updateCalculValue();
    //     }
    // }
    
    updateElement(newDataType: string, newOperationType: ExtractionOperation) {
        this.dataKey = newDataType;
        this.unity = magicDataUnity(newDataType);
        this.operation = newOperationType;
        this.updateCalculValue();
    }
    
    updateCalculValue() {
        if(this.dataKey === 'number') {
            this.value = this.associatedMeasures.length;
            return;
        }
        
        const mesuresData = this.associatedMeasures
            .map(m => m.dataInformations?.[this.dataKey])
            .filter(isNumber);
        
        switch (this.operation) {
            case ExtractionOperation.COUNT:
                this.value = mesuresData.length;
                this.unity = 'u';
                break;
            case ExtractionOperation.SUM:
                this.value = sum(mesuresData);
                break;
            case ExtractionOperation.AVERAGE:
                this.value = sum(mesuresData) / (mesuresData.length > 0 ? mesuresData.length : 1);
                break;
            default:
                this.value = 0;
        }
    }
}

export default ExtractionSheetArticleMeasuresElement;
 